import styles from "./index.module.scss";

interface Event {
    thumbnail: string;
    eventTitle: string;
}

interface MainTasksHeaderProps {
    event: Event;
    isNotEnglish: boolean;
}

const MainTasksHeader = ({ event, isNotEnglish }: MainTasksHeaderProps) => {
    const { thumbnail, eventTitle } = event;
    return (
        <>
            {thumbnail && (
                <div className={styles.image}>
                    <img alt="icon" src={thumbnail} />
                </div>
            )}
            <div className={styles.titleWrapper}>
                <div className={`${styles.title} ${isNotEnglish ? styles.notEnglish : ""}`}>
                    {eventTitle}
                </div>
            </div>
        </>
    );
};

export default MainTasksHeader;